import type {
  ThemeOptions,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';
import type { Theme } from '@ui/ThemeRegistry/theme.types';
import { MediaVariants } from './Media.types';

const defaultProps: ComponentsProps['Media'] = {
  variant: MediaVariants.default
};

const styleOverrides: ComponentsOverrides<Theme>['Media'] = {
  root: ({ theme }) => ({
    'position': 'relative',
    'display': 'block',
    'width': '100%',
    'height': '100%',
    'overflow': 'hidden',
    'maxHeight': 'inherit',

    'picture': {
      display: 'flex',
      width: '100%',
      height: '100%'
    },

    'img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.standard
      })
    },

    '&:hover img': {
      transform: 'scale(1.05)'
    }
  })
};

const createVariants = (theme: Theme): ComponentsVariants['Media'] => [
  {
    props: { variant: MediaVariants.default },
    style: {}
  },
  {
    props: { variant: MediaVariants.circle },
    style: {
      '&&': {
        aspectRatio: '1/1',
        width: '90cqi',
        maxWidth: '90cqi',
        height: '90cqi',
        maxHeight: '90cqi',
        margin: '5cqi',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        alignSelf: 'center',
        overflow: 'hidden',
        border: `1cqi solid var(--mui-palette-accent-main)`,

        picture: {
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },

        img: {
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          aspectRatio: '1/1',
          borderRadius: '50%'
        }
      }
    }
  },
  {
    props: { variant: MediaVariants.bordered },
    style: {
      'border': `2px solid var(--mui-palette-primary-main)`,
      'borderRadius': `var(--mui-shape-borderRadius)`,
      'overflow': 'hidden',

      'picture, img': {
        borderRadius: `calc(var(--mui-shape-borderRadius) - 2px)`
      }
    }
  }
];

export const mediaTheme = (theme: Theme): ThemeOptions => ({
  components: {
    Media: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default mediaTheme;
